module.exports = __webpack_public_path__ + "media/images/add_icon-c556307e6df640ae0f5ae217420faca7.png";